import React, { useEffect, useState } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import Api from "../../../utils/Api";

const TopCollectors = ({ compact = false }) => {
  const [collectors, setCollectors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Api.get("/stats/leaderboard")
      .then((res) => {
        setCollectors(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <Box>
      {!compact && (
        <Typography variant="h4" gutterBottom>
          Top 10 des meilleurs collectionneurs
        </Typography>
      )}

      {loading ? (
        <CircularProgress />
      ) : (
        collectors.slice(0, 10).map((user, index) => (
          <Box key={user.id} sx={{ mb: 1.5 }}>
            <Typography variant="body2">
              <strong>{index + 1}.</strong> {user.first_name} {user.last_name} —{" "}
              {user.badges_count} badge{user.badges_count > 1 ? "s" : ""}
            </Typography>
          </Box>
        ))
      )}
    </Box>
  );
};

export default TopCollectors;